<template>
    <div class="somaticTree-container">
        <div class="somatic-header">
            <button class="close-mobile" @click="dialog">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round" />
                    <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round" />
                </svg>
            </button>
            <h1>Показатели соматического статуса</h1>
            <div class="div-btn">
                <button @click="dialog" class="btn-list">К списку систем организма</button>
            </div>
            <div class="chapter-wrap-mobile">
                <div class="chapter-mobile">
                    <!-- <v-select outlined dense hide-details item-text="name" item-value="id" :items="listSystem" v-model="selectedItem" label="Системы организма" >
                            <template v-slot:prepend-item>
                                <v-avatar size="26" tile>
                                            <inline-svg :src="getIcon()" />
                                        </v-avatar>
                            </template>
                        </v-select> -->
                    <v-menu offset-y :close-on-content-click="true">
                        <template v-slot:activator="{ on }">
                            <div v-on="on" class="d-flex justify-space-between align-center"
                                style="height: 40px; width: 100%; border: 2px solid rgb(189, 185, 185); border-radius: 5px;">
                                <span style="margin-left: 10px;">{{ !activeName ? 'Системы организма' : activeName }}</span>
                                <v-icon>
                                    {{ 'mdi-chevron-down' }}
                                </v-icon>
                            </div>
                        </template>

                        <v-list class="d-flex flex-column">
                            <v-list-item v-for="(item, i) in listSystem" :key="i"
                                :color="selectedItem === i && !sex ? '#4854FE' : '#E882DD'" @click="tapList(item, i)"
                                style="margin-left: 10px;">
                                <v-list-item-icon>
                                    <v-avatar size="26" tile>
                                        <inline-svg :src="getIcon(item.icon)" />
                                    </v-avatar>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title class="text-menu">
                                        {{ item.name }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </div>
        </div>

        <div class="somaticTree_body">
            <div class="main-body-age">
                <div class="body_age" @click="isOpenSystem = !isOpenSystem">
                    <div class="div-filters">
                        <div>
                        <span>Возраст</span>
                        <span v-if="isOpenSystem">: {{ ageOnMonth }} мес</span>
                        </div>
                        <v-icon>
                            {{ 'mdi-chevron-down' }}
                        </v-icon>
                    </div>
                </div>
                <v-expand-transition>
                    <div class="age-top" v-if="isOpenSystem">

                        <v-slider class="slider-thumbs-custom" :class="{ 'female': sex, 'male': !sex }" :min="1" :max="18"
                            style="margin-bottom: 32px;" v-model="ageOnMonth" :tick-labels="tickLabelsSlider" step="1"
                            thumb-label="always" :thumb-size="34" :color="sex ? '#E882DD' : '#717BF9'"
                            :track-color="sex ? '#E882DD' : '#717BF9'">
                            <template v-slot:thumb-label></template>
                        </v-slider>

                        <div style="margin-bottom: 20px;" class="age_switch-container">
                            <p :class="{ 'male': !sex }">M</p>
                            <v-switch v-model="sex" color="#E882DD">
                            </v-switch>
                            <p :class="{ 'female': sex }">Ж</p>
                        </div>
                        <div class="body-img" v-if="showImage">
                            <humanImage :ageOnMonth="ageOnMonth" :gender="sex" :activeName="activeName"
                                :dialogSomaticName="dialogSomaticName" :heightOffset="386" style="height: 300px;" />
                        </div>
                    </div>
                </v-expand-transition>
            </div>


            <div class="body-info">
                <div class="body-text-s">
                    <v-card-text class="py-0 my-0" style="width: 100%;">
                        <v-card class="mx-auto" flat v-if="active">
                            <div v-for="(selection, i) in filterProperties(items, ageOnMonth * 12 * 30)" :key="'A' + i">
                                <h2>{{ i }}</h2>
                                <ul>
                                    <li v-for="(item, key) in selection" :key="'B' + key">
                                        <span class="text-item">
                                            {{ item.name }}, {{ item.value }}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </v-card>
                    </v-card-text>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import './index.scss'
import humanImage from "../../Student/HumanImage.vue";
import InlineSvg from 'vue-inline-svg';
import { mapGetters } from 'vuex'

export default {
    name: 'SomaticStatus',
    props: {
        listSystem: { type: Array, default: () => [] },
        defaultDataDS: { type: Array, default: () => [] },
    },
    components: { humanImage, InlineSvg },
    computed: {
        ...mapGetters({
            apiUrl: 'apiUrl'
        }),
        showImage() {
            if (
                this.activeName !== 'Антропометрические показатели' &&
                this.activeName !== 'Витальные показатели' &&
                this.activeName !== 'Лабораторные исследования'
            ) return true

            return false;
        }
    },
    watch: {
        sex() {
            this.tapList(this.active, this.selectedItem);
        }
    },
    data() {
        return {
            loadData: false,
            tickLabelsSlider: [1, '', '', '', '', 6, '', '', '', '', '', 12, '', '', '', '', '', 18],
            dialogSomaticName: null,
            ageOnMonth: 1,
            clientH: 688,
            selectedItem: null,
            clickShow: true,
            sex: false,
            width: 0,
            items: [{ name: '' }],
            active: null,
            activeName: null,
            isOpenSystem: false,
            tapLevel1index: null,
        }
    },
    methods: {
        tapList(item, index) {
            // console.log(item, index);
            let sex = this.sex ? [1, 2] : [0, 2];
            this.loadData = true;
            this.selectedItem = index;
            this.activeName = item.name;

            if (index === 0) {
                this.$http.post(`${this.apiUrl}Dictionary/GetAnthropometricIndicators`, sex)
                    .then((res) => {
                        this.items = [
                            {
                                name: 'Общее',
                                properties: res.data
                            }
                        ];
                        this.loadData = false;
                        this.active = item;
                    })
                return;
            }
            if (index === 1) {
                this.$http.post(`${this.apiUrl}Dictionary/GetVitalIndicators`, sex)
                    .then((res) => {
                        this.items = [
                            {
                                name: 'Общее',
                                properties: res.data
                            }
                        ];
                        this.loadData = false;
                        this.active = item;
                    })
                return;
            }
            if (index === 2) {
                this.$http.post(`${this.apiUrl}Dictionary/GetLabResearches`, sex)
                    .then((res) => {
                        this.items = res.data;
                        this.loadData = false;
                        this.active = item;
                    })
                return;
            }

            this.$http.post(`${this.apiUrl}Dictionary/GetSomaticStatuses?bodySystemId=${item.id}`, sex)
                .then((res) => {
                    // console.log(res.data);
                    this.items = res.data;
                    this.loadData = false;
                    this.active = item;
                })
        },
        getIcon(name) {
            if (name) return require(`../../../assets/SomaticStatus/${name}`)
            return ''
        },
        dialog() {
            this.activeName = null
            this.$emit('dialog', {})
        },
        filterProperties(array, ageOnDay) {
            // console.log(array);
            if(array.length > 0) {
                let res = [];

                for (let i = 0; i < array.length; i++) {
                for (let j = 0; j < array[i].properties.length; j++) {

                    let left = 0, right = array[i].properties[j].ageValues.length - 1;

                    while (left <= right) {
                        let middle = Math.floor((left + right) / 2), currentIteration = array[i].properties[j].ageValues[middle];

                        if (currentIteration.ageOnDay < ageOnDay) {
                            left = middle + 1;
                        } else if (currentIteration.ageOnDay > ageOnDay) {
                            right = middle - 1;
                        } else {
                            left = middle
                            break;
                        }
                    }

                    if (array[i].properties[j].ageValues[left] && array[i].properties[j].ageValues[left].ageOnDay == ageOnDay) {
                        res.push({
                            groupName: array[i].name,
                            name: array[i].properties[j].name,
                            value: this.returnResult(array[i].properties[j].ageValues[left])
                        })
                    } else if (array[i].properties[j].ageValues[left - 1] && array[i].properties[j].ageValues[left - 1].ageOnDay < ageOnDay) {
                        res.push({
                            groupName: array[i].name,
                            name: array[i].properties[j].name,
                            value: this.returnResult(array[i].properties[j].ageValues[left - 1])
                        })
                    }
                }
                }

                return res.reduce((group, product) => {
                const { groupName } = product;
                group[groupName] = group[groupName] ?? [];
                group[groupName].push(product);

                return group;
                }, {})
            }

            return {'Данных нет': []}
        },
        returnResult(obj) {
            let res = '';

            if (obj.valueType == 0) {
                if (obj.valueTo) {
                    res = `${obj.measurementName ? obj.measurementName + ': ' : ''}${obj.valueFrom}-${obj.valueTo}`
                } else {
                    res = `${obj.measurementName ? obj.measurementName + ': От ' : ''}${obj.valueFrom}`
                }
            } else if (obj.valueType == 1) {
                res = obj.valueText
            }

            return res
        },
    },
    created() {
        this.tapList({ id: 111, name: 'Антропометрические показатели', ord: 11, icon: 'ap.svg' }, 0)
        this.clientH = window.innerHeight;
    }
}
</script>
